import PropTypes from 'prop-types'

import styles from './Row.module.scss'

export const RowWrapper = ({ children }) => (
  <div className={styles.wrapper}>{children}</div>
)

RowWrapper.defaultProps = {
  children: null,
}

RowWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
}

export const Row = ({ children, classes, borderBottom, alignLeft }) => {
  let className = `${styles.row}`
  className += classes ? ` ${classes}` : ''
  className += borderBottom ? ` ${styles.borderBottom}` : ''
  className += alignLeft ? ` ${styles.alignLeft}` : ''
  return <div className={className}>{children}</div>
}

Row.defaultProps = {
  alignLeft: false,
  borderBottom: false,
  children: null,
  classes: null,
}

Row.propTypes = {
  alignLeft: PropTypes.bool,
  borderBottom: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.any,
  ]),
  classes: PropTypes.string,
}
